import React, { useEffect } from 'react';
import { getEnv } from '@config';
import { usePromotions, useScript } from '@hooks';
import { AppLoader } from '@components/AppLoader';

export const FalabellaSellerCredits = () => {
  const {
    tokenForInstallmentCreditWidget,
    getTokenForInstallmentCreditWidget,
    isInstallmentCreditTokenLoading,
    setTokenForInstallmentCreditLoading,
  } = usePromotions();

  const { sellerCheckingCreditUrl } = getEnv();
  useScript(sellerCheckingCreditUrl, 'module');

  useEffect(() => {
    getTokenForInstallmentCreditWidget();
    return () => {
      setTokenForInstallmentCreditLoading();
    };
  }, [getTokenForInstallmentCreditWidget, setTokenForInstallmentCreditLoading]);

  return (
    <>
      {isInstallmentCreditTokenLoading ? (
        <AppLoader />
      ) : (
        <falabella-seller-credits
          token={tokenForInstallmentCreditWidget}
          data-testId="finance-datamart-widget-checking-credit"
        />
      )}
    </>
  );
};

export default FalabellaSellerCredits;
